<app-main-menu></app-main-menu>
<div class="wrapper">
  <div class="page-header">
    <div class="page-header-image"></div>
    <div class="content">
      <div class="container">
        <div class="row">
          <div class="col-lg-5 col-md-6 offset-lg-0 offset-md-3">
            <div class="square square-7" id="square7"></div>
            <div class="square square-8" id="square8"></div>
            <div class="card card-register">
              <div class="card-header">
                <img
                  alt="Card image"
                  class="card-img"
                  src="assets/img/square1.png"
                />
                <h4 class="card-title text-capitalize ml-4">Login</h4>
              </div>
              <div class="card-body">
                <form (ngSubmit)="login()" class="form">
                  <div
                    class="input-group"
                    [ngClass]="{ 'input-group-focus': focus1 === true }"
                  >
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="tim-icons icon-email-85"> </i>
                      </div>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Email"
                      type="text"
                      (focus)="focus1 = true"
                      (blur)="focus1 = false"
                      [(ngModel)]="email"
                      name="email" 
                      required
                    />
                  </div>
                  <div
                    class="input-group"
                    [ngClass]="{ 'input-group-focus': focus2 === true }"
                  >
                    <div class="input-group-prepend">
                      <div class="input-group-text">
                        <i class="tim-icons icon-lock-circle"> </i>
                      </div>
                    </div>
                    <input
                      class="form-control"
                      placeholder="Password"
                      type="password"
                      (focus)="focus2 = true"
                      (blur)="focus2 = false"
                      [(ngModel)]="password"
                      name="password" 
                      required
                    />
                  </div>
                  <div class="m-2 text-danger">
                    <p class="text-danger">{{ errorMessage }} {{ error.message }}</p>
                  </div>
                  <div class="row flex-column align-items-center my-3">
                    <button [disabled]="!validateForm(email,password)" type="submit" class="btn btn-info btn-round btn-lg">
                        Iniciar Sesión
                    </button>
                    <div class="mb-1">¿Todavía no tienes una cuenta? <a href="#" routerLink="/register">Registrate</a></div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
        <div class="register-bg"></div>
        <div class="square square-1" id="square1"></div>
        <div class="square square-2" id="square2"></div>
        <div class="square square-3" id="square3"></div>
        <div class="square square-4" id="square4"></div>
        <div class="square square-5" id="square5"></div>
        <div class="square square-6" id="square6"></div>
      </div>
    </div>
  </div>
</div>
<app-footer></app-footer>
